import { createStore } from '@xstate/store'

export const apiBridge = createStore({
  context: {},
  emits: {
    logout: () => {},
  },
  on: {
    logout: (context, _event, enqueue) => {
      enqueue.emit.logout({})

      return {
        ...context,
      }
    },
  },
})
